var map = {
	"./avatars/avatar-kortical-team1/avatar-kortical-team1--mobile.webp": 15925,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2--mobile.webp": 22650,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3--mobile.webp": 9506,
	"./content/about-us-hero/about-us-hero--mobile.webp": 44901,
	"./content/about-us-security/about-us-security--mobile.webp": 65460,
	"./content/about-us-security1/about-us-security1--mobile.webp": 16898,
	"./content/about-us-sustainability/about-us-sustainability--mobile.webp": 64411,
	"./content/ai-consultancy-1/ai-consultancy-1--mobile.webp": 49902,
	"./content/ai-marketing-1/ai-marketing-1--mobile.webp": 31935,
	"./content/ai-marketing-3/ai-marketing-3--mobile.webp": 29811,
	"./content/ai-marketing-4/ai-marketing-4--mobile.webp": 19556,
	"./content/ai-marketing-5/ai-marketing-5--mobile.webp": 22357,
	"./content/ai-marketing-6/ai-marketing-6--mobile.webp": 92310,
	"./content/ai-marketing-7/ai-marketing-7--mobile.webp": 60099,
	"./content/ai-marketing-8/ai-marketing-8--mobile.webp": 36528,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1--mobile.webp": 39329,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2--mobile.webp": 91443,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3--mobile.webp": 69503,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4--mobile.webp": 76614,
	"./content/app-features-1/app-features-1--mobile.webp": 27050,
	"./content/app-features-2/app-features-2--mobile.webp": 68812,
	"./content/app-features-3/app-features-3--mobile.webp": 44683,
	"./content/app-features-4/app-features-4--mobile.webp": 898,
	"./content/app-features-5/app-features-5--mobile.webp": 48146,
	"./content/app-features-6/app-features-6--mobile.webp": 93395,
	"./content/art-innovation/art-innovation--mobile.webp": 97283,
	"./content/bg-abandoned-robot/bg-abandoned-robot--mobile.webp": 79111,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service--mobile.webp": 52422,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap--mobile.webp": 45990,
	"./content/bg-app/bg-app--mobile.webp": 56243,
	"./content/bg-blood/bg-blood--mobile.webp": 86133,
	"./content/bg-boxes/bg-boxes--mobile.webp": 83468,
	"./content/bg-clocks/bg-clocks--mobile.webp": 71155,
	"./content/bg-credit-score/bg-credit-score--mobile.webp": 51585,
	"./content/bg-cs-zappi/bg-cs-zappi--mobile.webp": 99290,
	"./content/bg-doctor/bg-doctor--mobile.webp": 94702,
	"./content/bg-email-automation/bg-email-automation--mobile.webp": 74269,
	"./content/bg-finance/bg-finance--mobile.webp": 96126,
	"./content/bg-ford/bg-ford--mobile.webp": 61591,
	"./content/bg-innovation/bg-innovation--mobile.webp": 17374,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing--mobile.webp": 68157,
	"./content/bg-notes/bg-notes--mobile.webp": 63607,
	"./content/bg-numbers/bg-numbers--mobile.webp": 87627,
	"./content/bg-pandas-profiling/bg-pandas-profiling--mobile.webp": 43301,
	"./content/bg-spacex/bg-spacex--mobile.webp": 53448,
	"./content/bg-superhuman-ai/bg-superhuman-ai--mobile.webp": 91002,
	"./content/bg-tac/bg-tac--mobile.webp": 13696,
	"./content/bg-tax/bg-tax--mobile.webp": 73896,
	"./content/bg-tech-nation-2/bg-tech-nation-2--mobile.webp": 59867,
	"./content/bg-tech-nation/bg-tech-nation--mobile.webp": 51127,
	"./content/bg-tower/bg-tower--mobile.webp": 71724,
	"./content/bg-what-is-ml/bg-what-is-ml--mobile.webp": 273,
	"./content/bg-wires/bg-wires--mobile.webp": 27305,
	"./content/bg-zappi/bg-zappi--mobile.webp": 3560,
	"./content/chess/chess--mobile.webp": 61887,
	"./content/comparisons-app-creation/comparisons-app-creation--mobile.webp": 87317,
	"./content/comparisons-team/comparisons-team--mobile.webp": 59792,
	"./content/cs-deloitte/cs-deloitte--mobile.webp": 23033,
	"./content/cs-email-automation/cs-email-automation--mobile.webp": 62549,
	"./content/cs-solution-architecture/cs-solution-architecture--mobile.webp": 29520,
	"./content/data-about-screenshot-1/data-about-screenshot-1--mobile.webp": 52814,
	"./content/data-about-screenshot-2/data-about-screenshot-2--mobile.webp": 37005,
	"./content/data-about-screenshot-3/data-about-screenshot-3--mobile.webp": 22856,
	"./content/data-more-about-img/data-more-about-img--mobile.webp": 76401,
	"./content/data-more-about-img2/data-more-about-img2--mobile.webp": 4263,
	"./content/data-more-about-img3/data-more-about-img3--mobile.webp": 59703,
	"./content/data-quote-simon-james/data-quote-simon-james--mobile.webp": 67292,
	"./content/feature-importances-long/feature-importances-long--mobile.webp": 95643,
	"./content/feature-importances-sales/feature-importances-sales--mobile.webp": 52147,
	"./content/feature-importances/feature-importances--mobile.webp": 5067,
	"./content/form-thank-you-smiley/form-thank-you-smiley--mobile.webp": 73159,
	"./content/gs-1-upload/gs-1-upload--mobile.webp": 38934,
	"./content/gs-2-target/gs-2-target--mobile.webp": 88173,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode--mobile.webp": 70152,
	"./content/gs-3-publishmodel/gs-3-publishmodel--mobile.webp": 87529,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit--mobile.webp": 80361,
	"./content/gs-5-businessvalue/gs-5-businessvalue--mobile.webp": 62891,
	"./content/gs-6-explainmodel/gs-6-explainmodel--mobile.webp": 31109,
	"./content/gs-8-deploymodel/gs-8-deploymodel--mobile.webp": 56716,
	"./content/gs-R-code/gs-R-code--mobile.webp": 58226,
	"./content/gs-python-code/gs-python-code--mobile.webp": 42883,
	"./content/icon-andy-signature/icon-andy-signature--mobile.webp": 13927,
	"./content/img-app-deployment/img-app-deployment--mobile.webp": 63492,
	"./content/img-app-explain/img-app-explain--mobile.webp": 37080,
	"./content/img-app-graphs/img-app-graphs--mobile.webp": 84564,
	"./content/img-app-leaderboard/img-app-leaderboard--mobile.webp": 94839,
	"./content/img-app-pension/img-app-pension--mobile.webp": 40904,
	"./content/img-app-training/img-app-training--mobile.webp": 14031,
	"./content/img-asaas/img-asaas--mobile.webp": 43346,
	"./content/img-credit-score-benefit/img-credit-score-benefit--mobile.webp": 99492,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new--mobile.webp": 80661,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline--mobile.webp": 89839,
	"./content/img-data-prep-preview/img-data-prep-preview--mobile.webp": 71511,
	"./content/img-kortical-timeline/img-kortical-timeline--mobile.webp": 10323,
	"./content/img-ml-vs-programming/img-ml-vs-programming--mobile.webp": 39135,
	"./content/img-nhs-app/img-nhs-app--mobile.webp": 2124,
	"./content/img-nhs-kortical/img-nhs-kortical--mobile.webp": 61907,
	"./content/img-nhs-optimiser/img-nhs-optimiser--mobile.webp": 95406,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain--mobile.webp": 98698,
	"./content/img-nhs-process/img-nhs-process--mobile.webp": 94174,
	"./content/img-platform-explain/img-platform-explain--mobile.webp": 53757,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon--mobile.webp": 6397,
	"./content/img-tac-graph/img-tac-graph--mobile.webp": 43784,
	"./content/img-what-is-ml/img-what-is-ml--mobile.webp": 29087,
	"./content/innovator-1/innovator-1--mobile.webp": 63474,
	"./content/intelligent-automation-1/intelligent-automation-1--mobile.webp": 41640,
	"./content/inventory-optimisation-1/inventory-optimisation-1--mobile.webp": 53041,
	"./content/inventory-optimisation-2/inventory-optimisation-2--mobile.webp": 93528,
	"./content/lego-unicorn-man/lego-unicorn-man--mobile.webp": 44863,
	"./content/podcasts-hero/podcasts-hero--mobile.webp": 55351,
	"./content/predicting-failures/predicting-failures--mobile.webp": 49894,
	"./content/reed-1/reed-1--mobile.webp": 55571,
	"./content/reed-2/reed-2--mobile.webp": 86820,
	"./content/reed-3/reed-3--mobile.webp": 2958,
	"./content/reed-4/reed-4--mobile.webp": 79607,
	"./content/screenshot-actions/screenshot-actions--mobile.webp": 2313,
	"./content/screenshot-feature-importances/screenshot-feature-importances--mobile.webp": 47441,
	"./content/screenshot-target-scores/screenshot-target-scores--mobile.webp": 55263,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart--mobile.webp": 60982,
	"./content/tech-nation-1/tech-nation-1--mobile.webp": 78270,
	"./content/unicorn-lego-man/unicorn-lego-man--mobile.webp": 45334,
	"./content/why-ml-10/why-ml-10--mobile.webp": 40077,
	"./content/why-ml-3/why-ml-3--mobile.webp": 82767,
	"./content/woman-developer-thinking/woman-developer-thinking--mobile.webp": 74066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37052;